import styled from 'styled-components';
import { Box } from '../../layout/Box';

export const ContentPromotionBox = styled(Box)
    .withConfig({ displayName: 'ContentPromotion' })
    .attrs({
        p: 2,
        mb: 2,
        borderRadius: 2,
        width: '100%',
        background: 'var(--background-primary)',
    })``;
